import React, { Component } from 'react';
import reactCSS from 'reactcss'


class MapDWColorPicker extends Component<any, any>{
  constructor(props: any) {
    super(props);
    console.log("MapDWColorPicker() > this.props", this.props);
  }
  state = {
    highPoint: this.props.layer ? this.props.layer.dwdataLayerStyle.highRenderedPoint : 8,
    lowPoint: this.props.layer ? this.props.layer.dwdataLayerStyle.lowRenderedPoint : 8,
  };

  updateNumberLow = (e: any) => {
    const val = e.target.value;
    this.setState({ lowPoint: val });
    this.props.handleChange(this.state.highPoint, val);
  }

  updateNumberHigh = (e: any) => {
    const val = e.target.value;
    this.setState({ highPoint: val });
    this.props.handleChange(val, this.state.lowPoint);
  }

  render() {
    const numberInput = reactCSS({
      'default': {
        swatch: {
          width: '47px',
          height: '23px',
          marginRight: '15px'
        }
      }
    });

    const divStyle = reactCSS({
      'default': {
        display: {
          display: 'inline-flex',
          width: '100%',
          paddingBottom: '10px'
        },
        tofrom: {
          height: '100%',
          paddingRight: '10px'
        },
        layerColor: {
          height: '100%',
          paddingRight: '10px'
        },
        colorPointPicker: {
          display: 'inline-flex',
          width: '100%'
        },
        colorPointPickerChild: {
          width: '100%'
        },
        saveButton: {
          marginLeft: '15px',
          alignSelf: 'center',
        },
      },
    });

    return (
      <div style={divStyle.colorPointPicker} >
        <div style={divStyle.colorPointPickerChild} >
          <div style={divStyle.display}>
            <div style={divStyle.tofrom}>Low: </div>
            <input
              style={numberInput.swatch}
              type='number'
              min='1'
              max='100'
              value={this.state.lowPoint}
              onChange={this.updateNumberLow}
              pattern="^-?[0-9]\d*\.?\d*$"
            />
            <div style={divStyle.tofrom}>High: </div>
            <input
              style={numberInput.swatch}
              type='number'
              min='1'
              max='100'
              value={this.state.highPoint}
              onChange={this.updateNumberHigh}
              pattern="^-?[0-9]\d*\.?\d*$"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default MapDWColorPicker